module.exports = __webpack_public_path__ + "img/example-security-healthcare-fr.6e86597b.jpg";